import Icon from "assets/icons";
import { Modal, ModalBody, ModalHeader } from "../modal";
import Button from "../button";
import Size from "shared/enums/Size";
import classNames from "classnames";

interface ModalPopupProps {
  children: React.ReactNode;
  onModalPopupClose?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  size?: Size;
  className?: string;
  headerContent?: React.ReactNode;
}

export default function ModalPopup(props: ModalPopupProps) {
  return (
    <Modal size={props.size} className={classNames("modalPopup", props.className)} onClose={props.onModalPopupClose}>
      <Button className="floatingModalCloseButton" onClick={props.onModalPopupClose} icon={<Icon.Close />} />
      {props.headerContent && <ModalHeader left={props.headerContent} />}
      <ModalBody>{props.children}</ModalBody>
    </Modal>
  );
}
